module.exports = __webpack_public_path__ + "img/google.48330a90.svg";